(function () {
    'use strict';
    var m = angular.module('widgets');
    m.factory('widgetsPaginationHelper', ["ref", function (ref) {
        return {
            currentPage: ref(0),
            totalPages: ref(0)
        };
    }]);
}());